"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = () => {
    const theme = (0, material_1.useTheme)();
    const mainTipBox = {
        minWidth: '81px',
        direction: 'ltr',
    };
    const percentageValue = {
        fontSize: '12px',
        px: 0.5,
    };
    const mostCommonStyle = {
        color: theme.palette.primary.main,
        pb: '4px',
        textAlign: 'center',
        minHeight: '22px',
        fontWeight: 500,
    };
    return {
        percentageValue,
        mostCommonStyle,
        mainTipBox,
    };
};
exports.default = useStyle;
